var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart_dialog"},[_c('div',{ref:"chart",staticClass:"chart"}),_c('div',{staticClass:"alarm"},_vm._l((_vm.alarm),function(item,index){return _c('div',{key:index},[_c('span',[_vm._v(_vm._s(item.name))]),_c('span',{staticClass:"value"},[_vm._v(_vm._s(item.value || 0))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }